import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import DOMPurify from "dompurify";

import Navbar from "sections/Navbars";
import Footer from "sections/Footers";
import Header from "sections/Headers";
import routes from "routes";
import footerRoutes from "footer.routes";
import bgImage from "assets/imgs/headers/bg-blog.jpg";

import { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";

import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";

import articleService from "services/articleService";
import { useAuth } from "auth/AuthProvider";
import { canAdmin } from "auth/roles";

import Medias from "./sections/Medias";

const Article = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [article, setArticle] = useState(null);
  const [previousArticle, setPreviousArticle] = useState(null);
  const [nextArticle, setNextArticle] = useState(null);

  useEffect(() => {
    const fetchArticleWithNeighbors = async () => {
      try {
        const { currentArticle, previousArticle, nextArticle } =
          await articleService.getArticleWithNeighbors(slug);
        setArticle(currentArticle);
        setPreviousArticle(previousArticle);
        setNextArticle(nextArticle);
      } catch (error) {
        console.error("Erreur lors de la récupération de l'article :", error);
      }
    };

    fetchArticleWithNeighbors();
  }, [slug]);

  async function onDelete() {
    if (!article) return;
    const ok = window.confirm(`Supprimer l’article « ${article.title} » ?`);
    if (!ok) return;
    try {
      await articleService.deleteArticle(article.slug);
      navigate("/blog");
    } catch (e) {
      alert("Suppression impossible.");
    }
  }

  if (!article) {
    return (
      <MKBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <MKTypography variant="h4">Chargement de l&apos;article...</MKTypography>
      </MKBox>
    );
  }

  const breadcrumbs = [
    { label: "Accueil", route: "/" },
    { label: "Blog", route: "/blog" },
    { label: article.title },
  ];

  return (
    <>
      <Navbar routes={routes} sticky />
      <Header bgImage={bgImage} title={article.title} breadcrumbs={breadcrumbs} />
      <Container sx={{ mt: -8, mb: 4 }}>
        <Card sx={{ p: 3, mx: { xs: 2, lg: 3 }, boxShadow: ({ boxShadows: { xxl } }) => xxl }}>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={10} lg={8}>
              <MKBox p={2} className="entry-content">
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                  <MKTypography variant="h3" component="h1">
                    {article.title}
                  </MKTypography>

                  {canAdmin(user) && (
                    <Tooltip title="Supprimer l’article">
                      <IconButton color="error" onClick={onDelete}>
                        <DeleteOutline />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>

                <MKTypography
                  variant="body1"
                  component="div"
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article.content) }}
                />
                <MKTypography variant="body2" color="textSecondary" mb={1}>
                  {article.author}, le {new Date(article.date).toLocaleDateString()}
                  &nbsp;à&nbsp;{new Date(article.date).toLocaleTimeString().substring(0, 5)}
                </MKTypography>

                {/* Médias joints */}
                <Medias media={article.media} />
              </MKBox>

              <MKBox display="flex" justifyContent="space-between" mt={4}>
                <MKBox>
                  {previousArticle ? (
                    <Link to={`/article/${previousArticle.slug}`}>
                      <MKTypography variant="body2" color="primary">
                        <ArrowBack sx={{ verticalAlign: "middle", mr: 0.5 }} />
                        {previousArticle.title}
                      </MKTypography>
                    </Link>
                  ) : (
                    <span />
                  )}
                </MKBox>

                <MKBox textAlign="right">
                  {nextArticle && (
                    <Link to={`/article/${nextArticle.slug}`}>
                      <MKTypography variant="body2" color="primary">
                        {nextArticle.title}
                        <ArrowForward sx={{ verticalAlign: "middle", ml: 0.5 }} />
                      </MKTypography>
                    </Link>
                  )}
                </MKBox>
              </MKBox>
            </Grid>
          </Grid>
        </Card>
      </Container>
      <MKBox pt={6} px={1} mt={6}>
        <Footer content={footerRoutes} />
      </MKBox>
    </>
  );
};

export default Article;
